
const Hero = () =>{
    return <section
    class="hero section"
    id="home"
    style={{backgroundImage: 'url(./images/bg-hero.jpg)'}}
  >
    <h1 className="hero__title">
      Start Your Day <br />
      With Favorite Coffee <br />
      And Cozy Place.
    </h1>
    <button className="hero__button">Order Now</button>
  </section>
}

export default Hero;